import {type HgAccordionBaseProps} from '~/design-system/hg/modules'
import HgAccordionBase from '~/design-system/hg/modules/HgAccordion/components/HgAccordionBase'

export default function HgComposableDetailsAccordion(props: HgAccordionBaseProps) {
  return (
    <div className="col-span-full">
      <HgAccordionBase {...props} />
    </div>
  )
}
